import React from 'react';
import { motion } from 'motion/react';
import { Check } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';

export function AboutSection() {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <section id="about" aria-label="About Aura Spaces" className={`py-12 sm:py-24 transition-colors duration-500 ${isDark ? 'bg-dark-bg' : 'bg-bg-light'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <motion.div 
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="aspect-4/5 rounded-tl-[80px] rounded-br-[80px] overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1616486338812-3dadae4b4ace?auto=format&fit=crop&q=60&w=800&fm=webp" 
                alt="Aura Spaces interior design team at work in Hyderabad studio" 
                className="w-full h-full object-cover"
              />
            </div>
            <div className={`absolute -bottom-8 -right-8 p-8 shadow-xl rounded-2xl hidden sm:block ${isDark ? 'bg-[#1E293B]' : 'bg-white'}`}>
              <div className={`text-3xl sm:text-4xl font-bold mb-1 ${isDark ? 'text-white' : 'text-primary'}`}>8+</div>
              <div className="text-sm text-accent uppercase tracking-widest font-semibold">Years of<br />Excellence</div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <p className="text-xs sm:text-sm font-bold text-accent uppercase tracking-widest mb-2">Who We Are</p>
            <h2 className={`text-xl sm:text-3xl lg:text-4xl font-poppins font-bold mb-4 sm:mb-6 text-balance leading-tight ${isDark ? 'text-white' : 'text-primary'}`}>
              Transforming Houses into Beautiful Homes
            </h2>
            <p className={`mb-6 leading-relaxed text-sm sm:text-base ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
              We started with a simple vision: to make premium interior design accessible, transparent, and hassle-free. Our approach combines aesthetic brilliance with functional mastery, ensuring every space we touch becomes a true reflection of its owner.
            </p>
            
            <ul className="space-y-4 mb-8">
              {[
                "100% Transparency from design to handover",
                "End-to-end execution with in-house team",
                "Custom designs tailored to your lifestyle",
                "Strict adherence to timelines & budgets"
              ].map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <div className="mt-1 bg-accent/10 p-1 rounded-full shrink-0">
                    <Check className="w-4 h-4 text-accent" />
                  </div>
                  <span className={`font-medium text-sm sm:text-base ${isDark ? 'text-gray-300' : 'text-gray-700'}`}>{item}</span>
                </li>
              ))}
            </ul>

            <div className={`pt-4 sm:pt-6 border-t ${isDark ? 'border-gray-700' : 'border-gray-200'}`}>
              <div className={`font-poppins text-lg sm:text-xl font-medium italic ${isDark ? 'text-white' : 'text-primary'}`}>Pavan Anne</div>
              <div className="text-xs sm:text-sm text-accent uppercase tracking-widest font-semibold">Founder</div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
